<template>
  <div :class="['pt-10 pb-5 component-div', isRTLlang(lang) ? 'rtl mrgn-rt-25' : '']">
    <b-row>
      <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
        <div class="number-sequence" :class="isFieldDisabled ? 'disable-question' : ''">
          <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
          <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
        </div>
        <span
          :class="['question-tital-name ml-2', isFieldDisabled ? 'disable-question' : '', isRTLlang(lang) ? 'question-heading-child' : '']"
          v-translate:_formattedBody="{
            key: translationKeyInitial,
            val: lang,
            html: componentData.formattedBody
          }"
          v-html="componentData.formattedBody"
        ></span>
        <span class="text-warning pl-5 fw-bold pt-10" v-if="hasFieldWarning">{{ fieldWarningText }}</span>
        <span
          class="text-danger pl-15 fw-bold"
          v-if="componentData && !componentData.isSkippable && componentData.optionsIds && !componentData.optionsIds.length && sendMultiChoiceData.showValidationMessage && !isFieldDisabled"
          v-translate:_required="{
            key: 'validation_error',
            val: lang,
            html: 'This field is required.'
          }"
        >
          This field is required.
        </span>

        <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isFieldDisabled ? 'disable-question' : ''" v-translate:_optional="{ key: 'label', val: lang, html: 'Optional' }" v-if="componentData.isSkippable">Optional</span>
        <span v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">Skipped</span>
        <div class="ml-5" v-if="componentData && componentData.notifications && componentData.notifications.length > 0 && isNotificationIcon">
          <img alt="Bell icon" src="@/assets/NotificaionIcon.png" data-v-c76994f4 />
        </div>
      </b-col>
    </b-row>
    <!-- PREVIEW MODE -->
    <template v-if="mode == 0">
      <b-row class="pt-10 pl-40 pb-10" v-if="componentData.hasBodyImage">
        <b-col cols="12" class="d-flex">
          <div class v-for="(img, index) in componentData.bodyImages" :key="index">
            <img :src="img.imageUrl" alt class="wid300" />
          </div>
        </b-col>
      </b-row>

      <b-row class="pl-40 pt-10">
        <b-form-group v-if="componentData.subType === 'Single'">
          <b-form-radio-group name="activityFormBooleanPreview" stacked disabled>
            <b-form-radio v-for="option in componentData.options" :key="option.id" :value="option.id">
              <span
                v-translate:_formattedBody="{
                  key: translationKeyInitial,
                  val: lang,
                  optionId: option.id,
                  optionLable: '_options_',
                  html: option.formattedBody
                }"
                v-html="option.formattedBody"
              ></span>
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>

        <b-form-group v-if="componentData.subType === 'Multi'">
          <b-form-checkbox-group name="activityFormBooleanPreview" stacked disabled>
            <b-form-checkbox v-for="option in componentData.options" :key="option.id" :value="option.id">
              <span
                v-translate:_formattedBody="{
                  key: translationKeyInitial,
                  val: lang,
                  optionId: option.id,
                  optionLable: '_options_',
                  html: option.formattedBody
                }"
                v-html="option.formattedBody"
              ></span>
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
        <b-col cols="8"></b-col>
      </b-row>
    </template>

    <!-- EDIT MODE -->
    <template v-else-if="mode == 1">
      <b-row class="pt-10 pl-40 pb-10" v-if="componentData.hasBodyImage" :class="isFieldDisabled ? 'disable-question' : ''">
        <b-col cols="12" class="d-flex">
          <div class v-for="(img, i) in componentData.bodyImages" :key="i">
            <img :src="img.imageUrl" alt class="wid300" />
          </div>
        </b-col>
      </b-row>
      <b-row class="pl-50" v-if="componentData.optionsIds" :class="isFieldDisabled ? 'disable-question' : ''">
        <b-form-group class="mb-5" v-if="componentData.subType === 'Single' || componentData.subType === undefined">
          <b-form-radio-group v-bind:class="isRTLlang(lang) ? 'rtl radio-position-inline' : ''" v-model="componentData.optionsIds[0]" v-validate="!componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined) ? 'required' : ''" stacked :disabled="isFieldDisabled" v-on:change="onChangeOptions($event)">
            <b-form-radio v-for="option in filteredOptions" :key="option.id" :value="option.id">
              <div class="ap-thread-alert-message-preview radio-mrgn-5">
                <span
                  v-translate:_formattedBody="{
                    key: translationKeyInitial,
                    val: lang,
                    optionId: option.id,
                    optionLable: '_options_',
                    html: option.formattedBody
                  }"
                  v-html="option.formattedBody"
                ></span>
                <AlertMessage v-if="componentData.colorCodeEnabled && componentData.optionsIds[0] === option.id" :message="option.colorCoding && option.colorCoding.warningMessage" :backgroundColor="option.colorCoding && option.colorCoding.color" />
              </div>
            </b-form-radio>

            <div v-if="otherOptionModel.isEnabled">
              <b-form-radio :key="otherOptionModel.id" :value="otherOptionModel.id">
                {{ otherOptionModel.label }}
              </b-form-radio>

              <div v-if="otherOptionModel.hasComment && isOtherSelected"
                   :class="{ 'disabled-area': !isOtherSelected, 'active-area': isOtherSelected }"
                   class="other-option-comment">
                    <textarea v-model="otherOptionModel.value"
                              :disabled="!isOtherSelected"
                              :maxlength="otherOptionModel.commentMaxLength"
                              :placeholder="otherOptionModel.comment"
                              class="other-option-comment-area"
                              @keydown="preventInvalidCharacters"
                              @change="onOtherCommentChange">
                    </textarea>

                <div :class="{'max-character-limit': otherCommentLength >= otherOptionModel.commentMaxLength}"
                     class="other-option-comment-count">
                  {{ otherCommentLength }} / {{ otherOptionModel.commentMaxLength }}
                </div>
              </div>

              <span v-if="isOtherSelected && otherOptionComponent.hasFieldError" class="text-danger fw-bold">{{ otherOptionComponent.colorCoding.warningMessage }}</span>
            </div>
          </b-form-radio-group>
          <div v-if="isRTLlang(lang)" class="float-right">
            <span class="activity-form__clear pl-50" :class="{ clearOptionDisabled: isFieldDisabled }" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>
            <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }" class="fs-12 pl-5">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                <span v-if="componentData.isSkippable && componentData.optionsIds.length == 0">{{ showScore(componentData.skipScore) }}</span>
                <span v-else>{{ componentData.actualScore }}</span>
              </div>
            </div>
          </div>
        </b-form-group>

        <b-form-group class="mb-5" v-if="componentData.subType === 'Multi'">
          <b-form-checkbox-group v-bind:class="isRTLlang(lang) ? 'rtl radio-position-inline' : ''" v-model="componentData.optionsIds" v-validate="!componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined) ? 'required' : ''" stacked :name="`multiChoice-${componentData.id}`" :disabled="isFieldDisabled" v-on:change="onChangeMultiOptions($event)">
            <b-form-checkbox v-for="option in filteredOptions" :key="option.id" :value="option.id" :disabled="disableCheckBox && noneOptionId != option.id">
              <div class="ap-thread-alert-message-preview radio-mrgn-5">
                <span
                  v-translate:_formattedBody="{
                    key: translationKeyInitial,
                    val: lang,
                    optionId: option.id,
                    optionLable: '_options_',
                    html: option.formattedBody
                  }"
                  v-html="option.formattedBody"
                ></span>
                <div
                  :style="{
                    marginBottom: componentData.colorCodeEnabled && option.colorCoding && option.colorCoding.color ? '10px' : ''
                  }"
                  v-for="(id, index) in componentData.optionsIds"
                  :key="index"
                >
                  <div v-if="componentData.colorCodeEnabled && id === option.id">
                    <AlertMessage :message="option.colorCoding && option.colorCoding.warningMessage" :backgroundColor="option.colorCoding && option.colorCoding.color" />
                  </div>
                </div>
              </div>
            </b-form-checkbox>

            <div v-if="otherOptionModel.isEnabled">
              <b-form-checkbox :key="otherOptionModel.id" :value="otherOptionModel.id">
                {{ otherOptionModel.label }}
              </b-form-checkbox>

              <div v-if="otherOptionModel.hasComment && isOtherSelected"
                   :class="{ 'disabled-area': !isOtherSelected, 'active-area': isOtherSelected }"
                   class="other-option-comment">
                    <textarea v-model="otherOptionModel.value"
                              :disabled="!isOtherSelected"
                              :maxlength="otherOptionModel.commentMaxLength"
                              :placeholder="otherOptionModel.comment"
                              class="other-option-comment-area"
                              @keydown="preventInvalidCharacters"
                              @change="onOtherCommentChange">
                    </textarea>

                <div :class="{'max-character-limit': otherCommentLength >= otherOptionModel.commentMaxLength}"
                     class="other-option-comment-count">
                  {{ otherCommentLength }} / {{ otherOptionModel.commentMaxLength }}
                </div>
              </div>
            </div>

            <span v-if="isOtherSelected && otherOptionComponent.hasFieldError" class="text-danger fw-bold">{{ otherOptionComponent.colorCoding.warningMessage }}</span>
          </b-form-checkbox-group>
          <div v-if="isRTLlang(lang)" class="float-right">
            <span class="activity-form__clear pl-50" :class="{ clearOptionDisabled: isFieldDisabled }" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>
            <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }" class="fs-12 pl-5">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                <span v-if="componentData.isSkippable && componentData.optionsIds.length == 0">{{ showScore(componentData.skipScore) }}</span>
                <span v-else>{{ componentData.actualScore }}</span>
              </div>
            </div>
          </div>
        </b-form-group>

        <b-col cols="8"></b-col>
      </b-row>
      <div v-if="lang != 'he' && lang != 'ar-IL'" :class="isFieldDisabled ? 'disable-question' : ''">
        <span class="activity-form__clear pl-50" :class="{ clearOptionDisabled: isFieldDisabled }" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>
        <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
          <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }" class="fs-12 pl-5">Score</label>
          <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
            <span v-if="componentData.isSkippable && componentData.optionsIds.length == 0">{{ showScore(componentData.skipScore) }}</span>
            <span v-else>{{ componentData.actualScore }}</span>
          </div>
        </div>
      </div>
    </template>

    <!-- RESPONSE MODE -->
    <template v-else-if="mode == 2">
      <span :class="{ 'query-icon': isEdited }"></span>
      <b-row>
        <b-col :class="componentData.isEditedVersion ? 'col-6' : 'col-10'" class="pl-30">
          <span class="changed" v-if="componentData.isEditedVersion"></span>

          <div v-if="componentData.subType === 'Multi'">
            <div v-for="(option, index) in filteredOptions" :key="index">
              <div :class="['answers ml-16', isRTLlang(lang) ? 'float-right' : '', { 'ap-multiple-choice-answer': option.id === answerId }]" v-for="(answerId, index) in componentData.optionsIds" :key="index">
<div v-if="option.id === answerId" class="ap-multichoice-option-answer">
                  <span
                    v-translate:_formattedBody="{
                      key: translationKeyInitial,
                      val: lang,
                      optionId: option.id,
                      optionLable: '_options_',
                      html: option.body
                    }"
                  >
                    {{ option.body }}
                  </span>
                  <AlertMessage v-if="componentData.colorCodeEnabled && componentData.answer" :message="option.colorCoding && option.colorCoding.warningMessage" :backgroundColor="option.colorCoding && option.colorCoding.color" />
                </div>
              </div>
            </div>

            <div :class="['answers ml-16', 'ap-multiple-choice-answer', isRTLlang(lang) ? 'float-right' : '']">
              <div v-if="otherAnswer" class="other-answer-display">
                <div class="other-answer-display-title">{{ otherOptionModel.label || "Other" }}:</div>
                <div class="other-answer-display-text">{{ otherAnswer }}</div>
              </div>
            </div>
          </div>

          <div :class="['answers ml-16', isRTLlang(lang) ? 'float-right' : '', 'ap-multiple-choice-answer']" v-if="componentData.subType === 'Single'">
            <span v-if="otherAnswer && otherAnswer.length" class="other-answer-display">
              <div class="other-answer-display-title">{{ otherOptionModel.label || "Other" }}:</div>
              <div class="other-answer-display-text">{{ otherAnswer }}</div>
            </span>

            <span
              v-else-if="!!componentData.optionsIds && componentData.optionsIds.length"
              v-translate:_formattedBody="{
                key: translationKeyInitial,
                val: lang,
                optionId: componentData.optionsIds[0],
                optionLable: '_options_',
                html: answerWithoutOther
              }"
            >
              {{ answerWithoutOther }}
            </span>

            <span v-else>{{ answerWithoutOther }}</span>

            <div>
              <div v-for="(option, index) in componentData.options" :key="index">
                <AlertMessage v-if="componentData.colorCodeEnabled && componentData.answer === option.formattedBody" :message="option.colorCoding && option.colorCoding.warningMessage" :backgroundColor="option.colorCoding && option.colorCoding.color" />
              </div>
            </div>
          </div>
          <div v-if="isRTLlang(lang)" :class="[isRTLlang(lang) ? 'clearfix' : '']"></div>
          <b-row class="pt-5">
            <div class="d-inline-block ml-16" v-if="activityInfo.canScoreResponses">
              <label class="pl-5" v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.actualScore) || showScore(componentData.skipScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
        <b-col v-if="componentData.isEditedVersion" class="col-6 previous-answer mb-12">
          <span class="previous-value-mark"></span>
          <div
            v-translate="{
              key: 'label_previous_value',
              val: lang,
              html: 'Previous value'
            }"
            class="answers previous-value"
          >
            Previous value
          </div>
          <div>
            {{ previousAnswerWithoutOther }}

            <div v-if="previousOtherAnswer" class="other-answer-display">
              <div class="other-answer-display-title">{{ otherOptionModel.label || "Other" }}:</div>
              <div class="other-answer-display-text">{{ previousOtherAnswer }}</div>
            </div>
          </div>
          <b-row class="pt-5" v-if="componentData.previousOptionsIds">
            <div class="d-inline-block" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.previousActualScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import AlertMessage from "../../common/alert-message";
import langTranslate from "./lang-translate";
import _ from "lodash";

export default {
  name: "activity-form-multi-choice-preview",

  mixins: [langTranslate],

  data() {
    return {
      hasFieldError: false,
      fieldErrorText: "",
      hasFieldWarning: false,
      fieldWarningText: "",
      scoresMap: {},
      noneOptionId: "",
      disableCheckBox: false,
      otherOptionModel: {}
    };
  },

  props: {
    componentData: {},
    isDisplayQuestionInfo: {
      default: true
    },
    isFieldDisabled: {
      type: Boolean,
      default: false
    },
    mode: {
      default: 0
    },
    isEdited: null,
    activityInfo: {
      default: () => {}
    },
    triggerValidate: {
      type: Boolean,
      default: false
    },
    isNotificationIcon: Boolean,
    showValidationMessage: {
      type: Boolean,
      default: false
    },
    sendMultiChoiceData: {
      type: Object,
      default: () => {}
    },
    id: {
      type: String,
      default: ""
    },
    nextStepSequence: null,
    isClearData: {
      type: Boolean,
      default: false
    },
    lang: String
  },
  components: {
    AlertMessage
  },
  watch: {
    triggerValidate() {
      if (!this.isFieldDisabled) {
        this.$validator.validateAll();
      }
    },
    isFieldDisabled(val) {
      if (val === true && this.componentData.branchingConfigured && this.componentData.optionsIds.length > 0 && !!this.nextStepSequence && this.nextStepSequence === this.componentData.stepSequence + 1) {
        this.clearAnswer();
      } else if (val === true) {
        this.resetField();
      }
    },
    componentData() {
      const noneOption = _.find(this.componentData.options, function(o) {
        return o.formattedBody ? o.formattedBody.toLowerCase() === "none" : false;
      });
      if (noneOption) {
        this.noneOptionId = noneOption.id;
      }
      if (this.componentData.otherOptionId && this.componentData.displayOtherOptionContentField) {
        const otherOption = this.componentData.options.find(option => {
          return option.id === this.componentData.otherOptionId;
        });
        if (!otherOption && this.mode == 2) {
          this.insertOtherOption();
        }
      }
    },
    // We need to make sure that "Other" is always the last option id so we don´t break the parsing logic
    "componentData.optionsIds": {
      handler: function(value) {
        if (!this.otherOptionModel.id || !value) {
          return;
        }

        const otherIdx = value.indexOf(this.otherOptionModel.id);
        const optionsLength = value.length - 1;

        if (otherIdx !== -1 && otherIdx < optionsLength) {
          this.componentData.optionsIds = [...value.filter(o => o !== this.otherOptionModel.id), this.otherOptionModel.id];
        }
      },
      deep: true
    },
    isClearData: {
      deep: true,
      handler(val) {
        if (val === true) {
          this.clearAnswer();
        }
      }
    }
  },
  mounted() {
    try {
      this.calculateScoresMap();
    } catch (e) {}
    if (this.mode == 1) {
      this.insertOtherOption();
      this.calculateScoresMap();
      this.$emit("initAnswerChange", this.componentData);
    }
    if (this.mode == 0 || this.mode == 2) {
      if (this.componentData.isSkippable && !(this.componentData.optionsIds && this.componentData.optionsIds.length > 0)) {
        this.componentData.actualScore = this.componentData.skipScore;
        this.componentData.computedScore = this.componentData.skipScore;
      }
    }
    if (this.mode == 2) {
      if (this.componentData.otherOptionId && this.componentData.displayOtherOptionContentField) {
        const otherOption = this.componentData.options.find(option => {
          return option.id === this.componentData.otherOptionId;
        });
        if (!otherOption) {
          this.insertOtherOption();
        }
      }
      if (!this.componentData.optionsIds) {
        this.componentData.optionsIds = [];
      }
      if (this.componentData.isSkippable && !(this.componentData.optionsIds && this.componentData.optionsIds.length > 0)) {
        this.componentData.previousActualScore = this.componentData.skipScore;
      }
    }

    this.otherOptionModel = {
      id: this.componentData.otherOptionId,
      isEnabled: this.componentData.displayOtherOptionContentField === true,
      hasComment: this.componentData.displayOtherCommentSelectedField === true,
      comment: this.componentData.otherCommentSelectedField,
      label: this.componentData.otherOptionContentField,
      commentMaxLength: 1000,
      value: this.otherAnswer
    };

    if (this.otherOptionModel.value && this.otherOption) {
      this.setOtherAnswer(this.otherOption.length === 2
          ? `${this.otherOptionModel.label}: ${this.otherOptionModel.value}`
          : this.otherOption.label
      );
    }

    this.componentData.options = this.getUniqueOptionsById(this.componentData.options, "id");
  },
  computed: {
    previousAnswerWithoutOther() {
      if (!this.componentData.previousAnswer) {
        return null;
      }

      const answerArr = this.componentData.previousAnswer.split(",");
      const otherIdx = this.componentData.previousOptionsIds.indexOf(this.componentData.otherOptionId);
      let result;

      if (otherIdx !== -1) {
        result = answerArr.filter((a, idx) => idx !== otherIdx).join(", ");
      } else {
        result = answerArr.join(", ");
      }

      return result;
    },
    previousOtherAnswer() {
      if (!this.componentData.previousAnswer) {
        return null;
      }

      const answerArr = this.componentData.previousAnswer.split(",");
      let result;

      const otherIdx = this.componentData.previousOptionsIds.indexOf(this.componentData.otherOptionId);

      if (otherIdx !== -1) {
        const otherAnswer = answerArr.find((a, idx) => idx === otherIdx).split(":");
        result = otherAnswer.length > 1 ? otherAnswer[1] : otherAnswer[0];
      }

      return result;
    },
    otherOptionComponent() {
      return this.componentData.options.find(o => o.id === this.componentData.otherOptionId);
    },
    answerWithoutOther() {
      if (!this.componentData || !this.componentData.options) {
        return null;
      }

      const otherIdx = this.componentData.optionsIds.indexOf(this.otherOptionModel.id);
      const answers = typeof this.componentData.answer === "string"
        ? this.componentData.answer.split(",").map(o => o.trim())
        : [];
      const otherAnswer = answers[otherIdx];

      if (otherAnswer && otherAnswer.indexOf(":") !== -1) {
        return answers.filter((a, idx) => idx !== otherIdx).join(", ");
      }

      return answers.join(", ");
    },
    otherAnswer() {
      const option = this.otherOption;

      if (!option || !option.length || !this.componentData.displayOtherCommentSelectedField) {
        return "";
      }

      return option.length === 2 ? `${option[1]}`.trim() : "";
    },
    otherOption() {
      if (!this.componentData || !this.componentData.options) {
        return null;
      }

      const otherOptionId = this.componentData.otherOptionId;
      const hasComment = this.componentData.displayOtherCommentSelectedField;

      if (!otherOptionId || !hasComment || !this.componentData.answer) {
        return null;
      }

      const sortedAnswers = this.componentData.options.map(o => o.id).filter(o => this.componentData.optionsIds.includes(o));
      const otherIdx = sortedAnswers.indexOf(otherOptionId);
      const answers = typeof this.componentData.answer === "string"
        ? this.componentData.answer.split(",").map(o => o.trim())
        : [];

      return otherIdx !== -1 ? answers[otherIdx].split(":").map(o => o.trim()) : null;
    },
    filteredOptions() {
      return this.componentData && this.componentData.options ? this.componentData.options.filter(q => q.id !== this.otherOptionModel.id) : [];
    },
    isOtherSelected() {
      if (this.otherOptionModel.id == null || !this.componentData.optionsIds) {
        return false;
      }

      return this.componentData.optionsIds.includes(this.otherOptionModel.id);
    },
    otherCommentLength() {
      return this.otherOptionModel.value ? this.otherOptionModel.value.length : 0;
    }
  },
  methods: {
    setOtherAnswer(answer) {
      const option = this.componentData.options.find(o => o.id === this.otherOptionModel.id);

      if (option) {
        option.body = answer;
        option.formattedBody = answer;
      }

      return option.body;
    },
    preventInvalidCharacters(event) {
      if (event.key === ":") {
        event.preventDefault();
      }
    },
    onOtherCommentChange(event) {
      const value = event.target.value;

      if (value && typeof value === "string") {
        event.preventDefault();
        this.otherOptionModel.value = value.replaceAll(":", "");
        this.$forceUpdate();
      }

      if (this.componentData.subType === "Single") {
        this.onChangeOptions(this.otherOptionModel.id);
      } else {
        this.onChangeMultiOptions(this.componentData.optionsIds);
      }
    },
    isRTLlang(lang) {
      return lang == "he" || lang == "ar-IL";
    },
    isScoreExcluded(answer) {
      let excludeScore = false;
      const option = this.componentData.options.find(option => option.body == answer);
      if (option) {
        excludeScore = option.excludeScore;
      }
      return excludeScore;
    },
    showScore(score) {
      if (score) {
        return score;
      }
      return 0;
    },
    resetField() {
      this.componentData.answer = undefined;
      this.componentData.optionsIds = [];
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
      this.componentData.dataChecks = [];
      this.hasFieldError = false;
      this.hasFieldWarning = false;
      this.sendMultiChoiceData.showValidationMessage = false;
      this.otherOptionComponent.hasFieldError = false;
      this.otherOptionModel.value = "";
      this.errors.clear();
      this.$emit("getQuestionScores");
    },
    clearAnswer() {
      this.disableCheckBox = false;
      this.resetField();
      this.componentData.dataChecks = [];
      this.$emit("onClearAnswer", this.componentData);
    },
    updateOtherOption() {
      if (this.otherOptionComponent) {
        this.otherOptionComponent.hasFieldError = false;
      }

      if (this.otherOptionModel.isEnabled) {
        if (this.otherOptionModel.hasComment && !this.otherOptionModel.value) {
          this.otherOptionComponent.hasFieldError = true;
        } else if (this.otherOptionModel.hasComment && this.otherOptionModel.value) {
          this.setOtherAnswer(`${this.otherOptionModel.label || "Other"}: ${this.otherOptionModel.value}`);
        } else {
          this.setOtherAnswer(`${this.otherOptionModel.label || "Other"}`);
        }
      }
      
      return this.otherOptionComponent ? !this.otherOptionComponent.hasFieldError : true;
    },
    onChangeOptions(e) {
      if (e === this.otherOptionModel.id && !this.updateOtherOption()) {
        return;
      }

      this.componentData.dataChecks = [];
      this.componentData.computedScore = this.scoresMap[e];
      this.componentData.actualScore = this.scoresMap[e];

      this.$emit("onValidateAnswer", this.sendMultiChoiceData);
      this.onAnswerChange();
    },
    onChangeMultiOptions(optionIdsOld) {
      let optionIds = optionIdsOld;
      this.disableCheckBox = false;

      if (optionIds.includes(this.noneOptionId)) {
        optionIds = [];
        this.componentData.optionsIds = [];
        optionIds.push(this.noneOptionId);
        this.componentData.optionsIds.push(this.noneOptionId);
        this.disableCheckBox = true;
      }
      if (optionIds instanceof Array) {
        if (!this.updateOtherOption()) {
          return;
        }

        this.componentData.computedScore = 0;
        this.componentData.actualScore = 0;
        optionIds.forEach(id => {
          for (const score in this.scoresMap) {
            if (score == id) {
              this.componentData.computedScore += this.scoresMap[score];
              this.componentData.actualScore += this.scoresMap[score];
            }
          }
        });
      } else {
        this.componentData.computedScore = this.scoresMap[optionIds];
        this.componentData.actualScore = this.scoresMap[optionIds];
      }
      this.onAnswerChange();
      this.$forceUpdate();
    },
    calculateScoresMap() {
      if (this.componentData.options) {
        this.componentData.options.forEach(option => {
          this.scoresMap[option.id] = option.score || 0;
        });
      }
    },
    onAnswerChange() {
      this.$nextTick(() => {
        this.$emit("onAnswerChange", this.componentData);
      });
    },
    insertOtherOption() {
      if (this.componentData.otherOptionId && this.componentData.displayOtherOptionContentField) {
        const sequence = this.componentData.options.length + 1;
        this.componentData.options.push({
          body: this.componentData.otherOptionContentField,
          colorCoding: {
            color: "#fff",
            warningMessage: "Please enter a comment"
          },
          enabled: true,
          excludeScore: false,
          formattedBody: this.componentData.otherOptionContentField,
          id: this.componentData.otherOptionId,
          isAdvancedScoring: false,
          priority: 0,
          score: this.componentData.otherScore,
          sendNotification: false,
          sequence: sequence
        });
      }
    },
    getUniqueOptionsById(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.component-div:hover .icons-div {
  display: block;
}
.changed {
  position: absolute;
  left: 0;
  top: 0;
  width: 10px;
  height: 60px;
  border-radius: 1px;
  background-color: #ffa200;
}

.previous-value-mark {
  width: 3px;
  height: 65px;
  background-color: #ffa200;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.answers {
  font-weight: 600;
}
.ap-multiple-choice-answer {
  margin: 2px 0px 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  .ap-multichoice-option-answer {
    display: flex;
  }
}
.ap-thread-alert-message-preview {
  display: flex;
  flex-wrap: wrap;

  span p {
    margin-bottom: 0px !important;
  }
}

.previous-answer {
  opacity: 0.8;
}

.previous-value {
  color: #ffa200;
  opacity: 0.8;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 9px;
  letter-spacing: 2.4px;
  margin-top: 3px;
}
.wid300 {
  max-width: 300px !important;
}
.activity-form__clear {
  width: 29px;
  height: 14px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4c8ce4;
}
.number-sequence {
  min-width: 30px;
  display: inline-block;
}
.component-div {
  border-top: 1px solid #fefefe;
  border-bottom: 1px solid #d3dfe4;
}
.cursor_pointer1 {
  cursor: pointer;
  width: 22px;
  height: 20px;
  border-radius: 4px;
  background-color: #c4c4c4;
  display: inline-block;
  color: #fff;
  text-align: center;
}
/deep/ .custom-control-label {
  white-space: normal !important;
}
.clearOptionDisabled {
  pointer-events: none !important;
}

.other-option-comment {
  position: relative;
  border-radius: 5px;
  box-shadow: 0 0 0 1px #4a4a4a;
  padding-bottom: 20px;
}

.disabled-area {
  background-color: rgb(245, 245, 245);
}

.active-area {
  box-shadow: 0 0 0 1px #007bff;
}

.other-option-comment-area {
  resize: none;
  width: 100%;
  padding: 10px;
  border: 0;
}

.other-option-comment-count {
  position: absolute;
  bottom: 5px;
  right: 10px;
  font-size: small;
}

.max-character-limit {
  color: crimson;
}

.other-answer-display {
  margin-top: 15px;
}

.other-answer-display-title {
  font-weight: bold;
  color: black;
}

.other-answer-display-text {
  font-style: italic;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-all;
  word-break: break-word;
  hyphens: auto;
}
</style>
